<app-header-title>
  <span title>{{'publicsetting.deductions'|translate}}</span>
</app-header-title>

<div class="publicsetting" style="padding: 0rem 3rem;">
  <dx-data-grid #grid class="dx-card wide-card" [dataSource]="customDataSource" [showBorders]="false"
    [focusedRowEnabled]="true" [focusedRowIndex]="0"[allowColumnResizing]="true"
  [columnAutoWidth]="true" [columnHidingEnabled]="true"
    [showColumnLines]="false" [rowAlternationEnabled]="true" [showRowLines]="false" [showBorders]="false"
    [errorRowEnabled]="false" [rtlEnabled]="currentLang=='ar'?true:false" (onRowUpdating)="updateRow($event)"
    (onInitNewRow)="onInitNewRow($event)" (onEditingStart)="onEditingStart()"
    (onEditorPreparing)="onEditorPreparing($event)">

    <dxo-editing mode="popup" [useIcons]="false" [allowAdding]="true" [allowDeleting]="true" [allowUpdating]="true"
      [texts]="button">
      <dxo-popup [title]="addpopup" [showTitle]="true" [width]="700" [height]="525" [hideOnOutsideClick]="true">
      </dxo-popup>

                  <dxo-form labelMode="floating" labelLocation="top"></dxo-form>

      <dxo-texts [addRow]="addrowfun('publicsettingnav.deductions')"
        confirmDeleteMessage="{{'tableinfo.deletebutton'|translate}}">
      </dxo-texts>
    </dxo-editing>


<dxo-paging  [pageSize]="10"> </dxo-paging>    <dxo-pager [visible]="true" allowedPageSizes="true" displayMode="full" [showPageSizeSelector]="true"
      [showInfo]="false" [showNavigationButtons]="true">
    </dxo-pager>
    <dxo-filter-row [visible]="true"></dxo-filter-row>

    <!--  <dxi-column
        dataField="id" [visible]="false"
        [width]="90"
        [hidingPriority]="2">
      </dxi-column> -->
    <dxi-column dataField="nameAr" [width]="190" caption="{{'tableinfo.NameAr'|translate}}" [hidingPriority]="8">

      <dxi-validation-rule type="required" message="{{'errors.namerequired'|translate}}">
      </dxi-validation-rule>
      <dxi-validation-rule type="stringLength" [max]="50"
        message="{{'errors.NameLength' |translate}}"></dxi-validation-rule>


      <dxi-validation-rule type="async" message="{{'errors.token'|translate}} !!" [validationCallback]="validateAsync">
      </dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="nameEn" caption="{{'tableinfo.NameEn'|translate}}" [hidingPriority]="6">
      <dxi-validation-rule type="async" message="{{'errors.token'|translate}} !!"
        [validationCallback]="validateAsyncForEn">
      </dxi-validation-rule>
      <dxi-validation-rule type="required" message="{{'errors.namerequired'|translate}}"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="description" caption="{{'tableinfo.description'|translate}}"></dxi-column>
    <dxi-column dataField="dateOfRegistration" dataType="date" [allowEditing]="false"
      caption="{{'tableinfo.dateOfRegistration'|translate}}"></dxi-column>
    <dxi-column dataField="valueType" caption="{{'tableinfo.valuetype'|translate}}"
      [setCellValue]="setCellValuetypevalue">
      <dxo-lookup [dataSource]="TypeValue" valueExpr="id" displayExpr="name"></dxo-lookup>
      <dxi-validation-rule type="required" message="{{'errors.namerequired'|translate}}">
      </dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="value" dataType="number" caption="{{'tableinfo.value'|translate}}">
      <dxi-validation-rule type="range" message="{{'errors.min'|translate}}" [min]="0">
      </dxi-validation-rule>
      <dxi-validation-rule type="range" message="{{'errors.max'|translate}}" [max]="100" *ngIf="type==2">
      </dxi-validation-rule>
      <dxi-validation-rule type="required" message="{{'errors.namerequired'|translate}}">
      </dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="taxableStatus" caption="{{'tableinfo.taxStatus'|translate}}" [visible]="false">
      <dxo-lookup [dataSource]="TaxableStatus" valueExpr="id" displayExpr="name"></dxo-lookup>
      <dxi-validation-rule type="required" message="{{'errors.namerequired'|translate}}">
      </dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="insuranceStatus" caption="{{'tableinfo.insuranceStatus'|translate}}" [visible]="false">
      <dxo-lookup [dataSource]="InsuranceStatus" valueExpr="id" displayExpr="name"></dxo-lookup>
      <dxi-validation-rule type="required" message="{{'errors.namerequired'|translate}}">
      </dxi-validation-rule>
    </dxi-column>
     <dxi-column dataField="isActive" dataType="boolean" caption="{{'tableinfo.isActive'|translate}}" >
        </dxi-column>
            <dxi-column dataField="IncludeInTotalDues" dataType="boolean" caption="{{'tableinfo.IncludeInTotalDues'|translate}}" [visible]="false" >
        </dxi-column>
      <dxi-column dataField="canUpdateValue" dataType="boolean" caption="{قابل لتعديل القيمة لموظف  }" >
        </dxi-column>
    <dxi-column type="buttons">
      <dxi-button name="edit" text="{{'tableinfo.editbutton'|translate}}"></dxi-button>
      <dxi-button name="delete" text="{{'tableinfo.removebutton'|translate}}"></dxi-button>

    </dxi-column> <dxo-remote-operations [groupPaging]="true">
    </dxo-remote-operations>
  </dx-data-grid>
</div>